/* eslint-disable camelcase */

class CreditCardSetup implements MerchantosCreditCardSetup {
  defaultAllowCredits: MerchantosCreditCardSetup['defaultAllowCredits'];

  constructor() {
    this.defaultAllowCredits = null;
  }

  onGatewayTypeChanged = ($gateway: JQuery<HTMLElement>) => {
    if (!$gateway) {
      console.error('A gateway type must be specified.');
    }

    this.hideUnusedFields($gateway);
    this.hideUnusedFieldGroups();
  };

  hideUnusedFields = ($gateway: TSFixMe) => {
    const gatewayType = $gateway.val();

    const $login = this.getGatewayConfigField('login');
    const $trans_key = this.getGatewayConfigField('trans_key');
    const $hash_value = this.getGatewayConfigField('hash_value');
    const $account_num = this.getGatewayConfigField('account_num');
    const $terminal_num = this.getGatewayConfigField('terminal_num');
    const $other_credentials1 = this.getGatewayConfigField('other_credentials1');
    const $other_credentials2 = this.getGatewayConfigField('other_credentials2');
    const $allow_credits = this.getGatewayConfigField('allow_credits');
    // var $merchantReceipt = this.getGatewayConfigField('merchant_receipt');

    // This part is used to reset the `allow_credits` checkbox to its original
    // value when it's not forced to true by default for the Mercury EMV Gateway
    // This sure is a shitty/hacky way to workaround the way this page was built.
    if (this.defaultAllowCredits !== null) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      $allow_credits.find('input').prop('checked', this.defaultAllowCredits);
      this.defaultAllowCredits = null;
    }
    switch (gatewayType) {
      case 'ElementExpressGateway':
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($login, 'Acceptor ID');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($trans_key, 'Account Token');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($account_num, 'Account ID');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($terminal_num, 'Terminal ID');
        // this.setFieldTitle($merchantReceipt, 'Print a merchant receipt for all transactions');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $login.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $trans_key.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $account_num.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $terminal_num.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $allow_credits.removeClass('hidden');
        // $merchantReceipt.removeClass('hidden');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $hash_value.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials1.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials2.addClass('hidden');
        break;

      case 'VantivUSGateway':
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($login, 'Merchant Number');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($account_num, 'Web Service Password');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($other_credentials1, 'Hosted Checkout ID');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($other_credentials2, 'Hosted Checkout Password');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($trans_key, 'Merchant ID');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        this.defaultAllowCredits = $allow_credits.find('input').prop('checked');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $allow_credits.find('input').prop('checked', true);

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $login.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $account_num.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials1.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials2.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $allow_credits.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $trans_key.removeClass('hidden');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $terminal_num.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $hash_value.addClass('hidden');
        break;

      case 'MercuryEMVGateway':
      case 'MercuryPaymentSystemsGateway':
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($login, 'Swiped Entry ID');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($account_num, 'Swiped Entry Password');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($other_credentials1, 'Manual Entry ID');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($other_credentials2, 'Manual Entry Password');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $login.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $account_num.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials1.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials2.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $allow_credits.removeClass('hidden');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $trans_key.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $terminal_num.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $hash_value.addClass('hidden');
        break;

      case 'MerchantWARE':
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($login, 'Name');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($account_num, 'Site ID');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($trans_key, 'Transaction Key');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $login.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $account_num.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $trans_key.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $allow_credits.removeClass('hidden');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $terminal_num.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $hash_value.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials1.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials2.addClass('hidden');
        break;

      case 'BarclaycardGateway':
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($login, 'Merchant ID');
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'JQuery<HTMLElement> | null' is n... Remove this comment to see the full error message
        this.setFieldTitle($account_num, 'Merchant Secret Key');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $login.removeClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $account_num.removeClass('hidden');

        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $trans_key.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $terminal_num.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $hash_value.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials1.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials2.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $allow_credits.addClass('hidden');
        break;

      case 'iZettleGateway':
      // FIXME [CLD-11240] Phase out Mercury Canada when all customers have been migrated to Vantiv Canada
      // eslint-disable-next-line no-fallthrough
      case 'MercuryCanadaGateway':
      case 'TestGateway':
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $login.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $account_num.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $trans_key.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $terminal_num.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $hash_value.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials1.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials2.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $allow_credits.addClass('hidden');
        break;

      case 'FirstDataGateway':
      case 'WorldlineGateway':
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $login.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $account_num.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $trans_key.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $terminal_num.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $hash_value.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials1.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $other_credentials2.addClass('hidden');
        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
        $allow_credits.removeClass('hidden');
        break;

      default:
        console.error('Unknown gateway type specified');
        break;
    }
  };

  getGatewayConfigField = (fieldName: string) => {
    const fieldId = `view_cc_setup_id_${fieldName}`;

    const $configField = $(`#${fieldId}`);

    return $configField.length ? $configField.closest('tr') : null;
  };

  hideUnusedFieldGroups = () => {
    $('.view_field_box').each((_index, $fieldGroup) => {
      let $hasFields = false;

      $($fieldGroup)
        .find('tr[id^=view_f_]')
        .each((_index, $field) => {
          if (!$($field).hasClass('hidden')) {
            $hasFields = true;
          }
        });
      if (!$hasFields) {
        $($fieldGroup).addClass('hidden');
      } else {
        $($fieldGroup).removeClass('hidden');
      }
    });
  };

  setFieldTitle = ($field: JQuery<HTMLElement>, title: string) => {
    $field.find('label').text(title);

    // update the placeholder text if necessary
    const $fieldInput = $field.find('input');
    if ($fieldInput.prop('placeholder').length) {
      $fieldInput.prop('placeholder', title);
    }
  };
}

window.merchantos.credit_card_setup = new CreditCardSetup();
